import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
//let idUserPublic = localStorage.getItem('id');
export class QuickSightService {
  constructor(private http: HttpClient) {}
  getEmbedUrl(context : String): Observable<string> {
    let apiUrl = "";
    if (context === 'fleetUse') {
      apiUrl = `${environment.endpointQuicksight}/tablero/usabilidad`; 
    }
    else if (context === 'speedLimit') {
      apiUrl = `${environment.endpointQuicksight}/speeding`;
    }
    else if (context === 'pe') {
      apiUrl = `${environment.endpointQuicksight}/pe`;
    }
    let config = {
        headers: {
          'id-client': localStorage.getItem('idcliente'),
          Authorization: `Bearer ${localStorage.getItem('at')}`,
        },
    };
    return this.http.get<any>(apiUrl, config).pipe(
      map(response => {
        if (response.embedUrl) {
          const parsedBody = response.embedUrl;
          return parsedBody;
        }
        throw new Error("No se pudo obtener la URL del tablero");
      })
    );
  };
}
